import React, { useEffect, useState } from 'react'
import './ViewAdmins.css'

import api from '../../Common/Api/UserApi';
import Cookies from 'universal-cookie';
import { useSelector } from 'react-redux'

const ViewAdmins = () => {
    const {BookWormUser} = useSelector((state)=>state)

    const {userInfo} = BookWormUser
    
    const[admins,setAdmins] = useState([]);
    const[email,setEmail] = useState('');

    const OnEmailChange = (e)=>{
        e.preventDefault();
        setEmail(e.target.value)
    }

    const cookies = new Cookies();
    const fetchAdmins = async()=>{
       
        const res = await api.get('/admin/admins',{
            user:{
                _id: userInfo._id
            }
        },{
            headers:{
                'Authorization': `Bearer ${cookies.get('token')}`
            }
        })

        console.log('res from get admins : ', res);
        setAdmins(res.data.admins);
    }

    const handleDeleteAdmin = async(element)=>{

        // todo take input in alert

        let flag = prompt("Pleasy type ' CONFIRM ' to continue Removing this Admin");
        if(flag!=='CONFIRM'){
            return;
        }

        let userEmail = element.email;
        console.log('Element from del btn',element);

        if(userEmail==userInfo.email)
        {
            alert('You Cannot Remove Yourself from Admin');
            return;
        }
        
        api.delete('/admin/admins/delete',{
            userEmail : userEmail
        },{
            headers:{
                'Authorization': `Bearer ${Cookies.get('token')}`
            }
        }).then(()=>alert('Admin Updated successfully !')).catch((err)=>{
            console.log(err)
            alert(err)
        })
    }

    const handleAddAdmin=async()=>{
        let flag = prompt("Pleasy type ' CONFIRM ' to Continue");
        if(flag!=='CONFIRM'){
            return;
        }

        if(email===userInfo.email)
        {
            alert('You Are Already Admin');
            return;
        }

        api.post('/admin/admins/add',{
            userEmail:email
        }).then(()=>alert('Admin updated successfully !')).catch((err)=>{
            console.log(err);
            alert(err)
        })
    }

    useEffect(() => {
        fetchAdmins();
    }, [])


  return (
    <div className='req-container'>

        <h2>Add Admin</h2>
        <div className='add-admin-cont'>
            <label>Enter User's Email Id to make Admin : </label>
            <input type='text'></input>
            <button onClick={handleAddAdmin}>ADD</button>
        </div>

        <h2>Admins Info </h2>
        <div className='row'>
        {
            admins.map((element)=>{
                return (
                    <div className=' col-md-6' style={{padding:"1%"}}>
                        <div className="card mb-3" style={{maxWidth:"100%"}} >
                            <div className="row g-0">
                            
                                <div className="col-md-8">
                                    <div className="card-body">
                                    
                                        <h4> Name : {element.name}</h4>
                                        <h6> email : {element.email}</h6>

                                    </div>
                                        
                                </div>
                            </div>
                            <div className='admin-btn-container'>
                                        
                                <i className="fa-solid fa-trash-can" onClick={()=>handleDeleteAdmin(element)}></i>
                            </div>
                        </div>

                    </div>
                )
            })
        }
        </div>

        
    </div>
  )
}

export default ViewAdmins